async function handleSecondaryProductLogic(event, mainProductQuantity) {
    return new Promise((resolve, reject) => {
        try {
            // Determine the correct product data element based on the variant ID
            let productDataElement = document.getElementById(`product-data-${event.variantId}`);
            if (!productDataElement) {
                productDataElement = document.getElementById("product-data") || document.getElementById("main-product-data");
            }
            if (!productDataElement) {
                console.error("Product data element not found.");
                return resolve(null);
            }

            console.log("Product data element found with ID:", productDataElement.id);
            console.log("Product data:", productDataElement.id);

            const productDataAttr = productDataElement.dataset.product;
            const metafieldsAttr = productDataElement.dataset.metafields;

            if (!productDataAttr || !metafieldsAttr) {
                console.error("Product data or metafields attribute not found or is empty.");
                return resolve(null);
            }

            const productData = JSON.parse(productDataAttr);
            const metafieldsData = JSON.parse(metafieldsAttr);
            console.log("Product Data:", productData);
            console.log("Metafields Data:", metafieldsData);

            // Use the variant ID passed from the event
            const variantId = event.variantId;
            console.log("Variant ID to search:", variantId);

            // Fetch pallet quantity metafield from hidden input or express option list
            let palletRows = null;
            const variantMetafieldInput = document.querySelector(`input[name="variant_metafields_${variantId}"]`);
            if (variantMetafieldInput) {
                try {
                    const variantMetafieldsData = JSON.parse(variantMetafieldInput.value);
                    console.log("Parsed Variant Metafields Data from hidden input:", variantMetafieldsData);
                    const variantPalletQtyMetafield = variantMetafieldsData.pallet_qty;
                    console.log("Variant Pallet Quantity Metafield:", variantPalletQtyMetafield);
                    if (variantPalletQtyMetafield && !isNaN(parseInt(variantPalletQtyMetafield))) {
                        palletRows = parseInt(variantPalletQtyMetafield);
                    } else {
                        console.warn("Variant pallet_qty metafield is blank or invalid. Falling back to product-level metafield.");
                    }
                } catch (e) {
                    console.error("Error parsing variant metafields from hidden input:", e);
                }
            } else {
                // Try to find the variant metafields from the express option list
                const variantElement = document.getElementById(`${variantId}-radio`) || document.querySelector(`[data-variant-id="${variantId}"]`);
                if (variantElement && variantElement.dataset.metafields) {
                    try {
                        console.log("Variant Metafields Attribute from express option list:", variantElement.dataset.metafields);
                        const variantMetafieldsData = JSON.parse(variantElement.dataset.metafields);
                        console.log("Parsed Variant Metafields Data from express option list:", variantMetafieldsData);
                        const variantPalletQtyMetafield = variantMetafieldsData.pallet_qty;
                        console.log("Variant Pallet Quantity Metafield from express option list:", variantPalletQtyMetafield);
                        if (variantPalletQtyMetafield && !isNaN(parseInt(variantPalletQtyMetafield))) {
                            palletRows = parseInt(variantPalletQtyMetafield);
                        } else {
                            console.warn("Variant pallet_qty metafield is blank or invalid. Falling back to product-level metafield.");
                        }
                    } catch (e) {
                        console.error("Error parsing variant metafields from express option list:", e);
                    }
                } else {
                    console.warn("Variant metafields input not found for variant ID:", variantId);
                }
            }

            // If no valid variant pallet quantity metafield, fallback to product pallet quantity metafield
            if (!palletRows) {
                console.log("No valid pallet quantity in variant metafield, falling back to product metafield.");
                if (metafieldsData && metafieldsData.pallet_qty && !isNaN(parseInt(metafieldsData.pallet_qty))) {
                    palletRows = parseInt(metafieldsData.pallet_qty);
                }
                console.log("Product Pallet Quantity Metafield:", palletRows);
            }

            if (!palletRows) {
                console.log("No pallet quantity metafield found at both variant and product levels.");
                return resolve([]);  // No secondary product found
            }

            console.log("Pallet quantity used in calculation:", palletRows);
            const palletQuantity = Math.ceil(mainProductQuantity / palletRows);

            // Determine pallet product variant ID based on pallet_product metafield value
            let palletVariantId;
            if (metafieldsData.pallet_product === "Regular Pallet") {
                palletVariantId = 45371400880302;
            } else if (metafieldsData.pallet_product === "Grass Pallet") {
                palletVariantId = 45371411136686;
            } else {
                palletVariantId = 45371400880302; // Default fallback
            }

            console.log("Secondary product to be added:", palletVariantId, "Quantity:", palletQuantity);

            // Only return the secondary product (pallet)
            return resolve([
                { id: palletVariantId, quantity: palletQuantity }
            ]);
        } catch (error) {
            console.error("Error in secondary product logic:", error);
            reject(error);
        }
    });
}
